export enum NOT_POSSIBLE_OPERATION_TYPES {
  OPERATION = 'operation',
  AUTHORIZATION = 'authorization',
}
